<template>
  <div class="pa-4">
    <v-row>
      <v-col cols="3">
        <div class="d-flex flex-row mb-2">
          <span class="headline">個人資訊</span>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            dark
            color="orange"
            @click="$refs.editAccountDialog.show(profile)"
            >編輯</v-btn
          >
        </div>
        <v-card outlined>
          <v-card-text class="py-2">
            <v-row>
              <template v-for="row in accountProfile">
                <v-col
                  cols="12"
                  xl="3"
                  :class="{ 'pb-0': $vuetify.breakpoint.lgAndDown }"
                  v-text="row.key"
                  :key="`${row.key}-key`"
                ></v-col>
                <v-col
                  cols="12"
                  xl="9"
                  class="black--text"
                  :key="`${row.key}-value`"
                >
                  <pre
                    :class="{ overline: row.key === '密碼' }"
                    style="white-space: pre-wrap;word-wrap: break-word;"
                    >{{ row.value }}</pre
                  >
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="9">
        <div class="d-flex flex-row mb-2">
          <span class="headline">寵物資訊</span>
          <v-spacer></v-spacer>
        </div>
        <card-pet
          :phone="phone"
          ref="cardPet"
          showCreateNew="true"
          :clinic="$my.getClinic()"
          @onSelect="
            petId => {
              $router.push(
                `/accountManage/profile/${phone}/petProfile/${petId}/0`
              );
            }
          "
          @createNew="$refs.editPetDialog.create(profile.phone, profile.name)"
        ></card-pet>
      </v-col>
    </v-row>
    <dialog-edit-account-profile
      ref="editAccountDialog"
      @done="getProfile"
    ></dialog-edit-account-profile>
    <dialog-edit-pet-profile
      ref="editPetDialog"
      @done="$refs.cardPet.getPets()"
    ></dialog-edit-pet-profile>
    <socket-io :focusEvent="focusEvent" @onReceive="updateAvatar"></socket-io>
  </div>
</template>
<script>
import DialogEditAccountProfile from "./DialogEditAccountProfile";
import DialogEditPetProfile from "./DialogEditPetProfile";
import CardPet from "../common/CardPet";
import SocketIo from "../common/SocketIo";

export default {
  props: ["phone"],
  components: {
    DialogEditPetProfile,
    DialogEditAccountProfile,
    CardPet,
    SocketIo
  },
  data: () => ({
    focusEvent: ["updateAvatar"],
    profile: {},
    accountProfile: [
      {
        key: "姓名",
        value: ""
      },
      {
        key: "電話",
        value: ""
      },
      {
        key: "密碼",
        value: "●●●●●●●"
      },
      {
        key: "權限",
        value: ""
      },
      {
        key: "群組",
        value: ""
      },
      {
        key: "備註",
        value: ""
      }
    ],
    createBtnRipple: false
  }),
  methods: {
    async getProfile() {
      let response = await this.$ajax.post(
        `${this.$config.apiUrl}/${this.$my.getClinic()}/search/user`,
        { phone: this.phone }
      );
      console.log(JSON.stringify(response.data[0]));
      this.accountProfile[0].value = response.data[0].name;
      this.accountProfile[1].value = response.data[0].phone;
      this.accountProfile[3].value = this.$common.parsePermission(
        response.data[0].permission
      );
      this.accountProfile[4].value = response.data[0].clinic;
      this.accountProfile[5].value = response.data[0].info;

      this.profile = response.data[0];
    },
    // async getPet() {
    //   let response = await this.$ajax.get(
    //     `${this.$config.apiUrl}/${this.$my.getClinic()}/pets/${this.phone}/0`
    //   );
    //   this.$refs.cardPet.setPets(response.data);
    // },
    updateAvatar(event, { petId, phone }) {
      if (phone === this.phone) {
        this.$refs.cardPet.reloadPetAvatar(petId);
      }
    }
  },
  mounted() {
    this.getProfile();
    // this.getPet();
  }
};
</script>
